<template>
  <div>
    <el-collapse-transition v-if="$route.name == 'Read'">
      <div class="header-bg" style="height: 41px">
        <div class="header">
          <a class="logo" style="margin-left: 1%">
            <!-- <span
              class="logo-font FangZheng-FanTi-Kaiti"
              style="font-size: 2.5632rem; margin-right: 5px"
              >古籍</span
            > -->
            <div class="logobox" style="margin-right: 4%">
<!--               <img src="/static/logobox.png" alt="" /> -->
              <i class="el-icon-s-home" style="font-size: 18px;
    color: #F5EBC9;" @click="goHome"></i>
            </div>
            <div>
              <div class="logo-font" :title="bookName">{{truncateText(bookName)}}</div>
            </div>
            <div>
              <div class="fontNew2" >{{writer}}</div>
            </div>
            <div>
              <div class="fontNew2" :title="bookVersion">{{truncateText(bookVersion)}}</div>
            </div>
            <div>

            </div>

          </a>
          <div class="headcenter">
<!--            <div class="fontNew">{{writer}}</div>
            <div class="fontNew">{{bookVersion}}</div>-->
            <el-dropdown class="icons">
              <span class="el-dropdown-link keyicon">
                <img
                  @click="goPartSearch"
                  style="width: 18px; height: 18px;margin-top: 5px;"
                  src="/static/homenew/1.png"
                  alt=""
                />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click="goPartSearch"
                >部件检索</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown class="icons" v-if="isLogin">
              <button @click.stop="toPath('/uc')">
                <img
                  v-if="!isVip"
                  src="/static/homenew/user.svg"
                  class="buttonImg"
                  style="width: 20px; height: 20px;margin-top: 5px;"
                />
                <div v-else><img src="/static/homenew/user.svg" style="width: 20px; height: 20px;margin-top: 5px;"/></div>
              </button>
              <el-dropdown-menu slot="dropdown">
                <a @click.stop="toPath('/uc')"
                ><el-dropdown-item>用户中心</el-dropdown-item></a
                >
                <a @click.stop="getout"
                ><el-dropdown-item>退出</el-dropdown-item></a
                >
                <!-- <router-link :to="{path:'/uc'}"><el-dropdown-item>用户中心</el-dropdown-item></router-link> -->
              </el-dropdown-menu>
            </el-dropdown>
            <div v-else class="icons" style="width: 96px;height: 32px;margin-left: 10px">
              <button @click.stop="toPath('/loginNew')" style="display: flex;padding: 5px 10px;width: 96px;height: 32px;background: #FFFFFF;border-radius: 16px;font-family: PingFangSC, PingFang SC;font-weight: 500;font-size: 16px;color: #573E0D;">
                <img src="/static/homenew/userNew.png" style="width: 14px;height: 13px;margin-top: 5px;margin-right: 10px;margin-left: 10px" /><span>登录</span>
              </button>
              <!--              <el-dropdown-menu slot="dropdown">
                              <a @click.stop="toPath('/login')"
                                ><el-dropdown-item>登録</el-dropdown-item></a
                              >
                            </el-dropdown-menu>-->
            </div>
          </div>
<!--          <div style="z-index: 9" class="align-center">


          </div>-->
        </div>
      </div>
    </el-collapse-transition>
    <el-collapse-transition v-else>
      <div class="header-bg">
        <div class="header">
          <a class="logo" @click.stop="toPath('/')">
            <!-- <span
              class="logo-font FangZheng-FanTi-Kaiti"
              style="font-size: 2.5632rem; margin-right: 5px"
              >古籍</span
            > -->
            <div class="logobox">
              <!-- <img src="/static/logobox.png" alt="" /> -->
            </div>
            <div>
              <div class="logo-font">天禄云枢·四库全书数据库</div>
              <div class="logo-name">专业&nbsp;&nbsp;·&nbsp;&nbsp;开放&nbsp;&nbsp;·&nbsp;&nbsp;智能</div>
            </div>

          </a>
          <!-- <div class="flex-grow nav">
        <router-link
          type="primary"
          v-for="item in list"
          :to="item.path"
          :key="item.path"
          :underline="false"
          style="color: #fff; margin-left: 2rem"
          >{{ item.title }}</router-link
        >
      </div> -->
          <div class="headcenter">
            <div>
              <div
                :class="
                ($route.name == 'Search'||(($route.name == 'Read')&&($route.query.from&&($route.query.from=='sousuo'))))
                  ? 'menucontent  activemetl'
                  : 'menucontent'
              "
                @click.stop="toSearch('/search')"
              >
                <a @click.stop="toSearch('/search')">检索查询</a>
              </div>
              <div class="navLine" v-show="$route.name == 'Search'"></div>
            </div>
            <div>
              <div
                :class="
                 ($route.name == 'Books'||(($route.name == 'Read')&&($route.query.from&&($route.query.from=='shujia'))))
                  ? 'menucontent  activemetl'
                  : 'menucontent'
              "
                @click.stop="toSearch('/books')"
              >
                <a @click.stop="toSearch('/books')">书架</a>
              </div>
              <div class="navLine" v-show="$route.name == 'Books'"></div>
            </div>
            <div>
              <div
                :class="
                 ($route.name == 'bookList' || $route.name == 'GoBooks'||(($route.name == 'Read')&&($route.query.from&&($route.query.from=='shudantuijian'))))

                  ? 'menucontent  activemetl'
                  : 'menucontent'
              "
                @click.stop="toSearch('/booklist')"
              >
                <a @click.stop="toSearch('/booklist')">书单推荐</a>
              </div>
              <div class="navLine" v-show="$route.name == 'bookList' || $route.name == 'GoBooks'"></div>
            </div>
            <div>
              <div
                :class="
                $route.path == '/introduce/1'
                  ? 'menucontent  activemetl'
                  : 'menucontent'
              "
                @click.stop="toSearch('/introduce/1')"
              >
                <a @click.stop="toSearch('/introduce/1')">系统介绍</a>
              </div>
              <div class="navLine" v-show="$route.path == '/introduce/1'"></div>
            </div>
            <div>
              <div
                :class="
                $route.path == '/introduce/0'
                  ? 'menucontent  activemetl'
                  : 'menucontent'
              "
                style="margin-right: 50px"
                @click.stop="toSearch('/introduce/0')"
              >
                <a @click.stop="toSearch('/introduce/0')">通知公告</a>
              </div>
              <div class="navLine" v-show=" $route.path == '/introduce/0'"></div>
            </div>
            <div class="fontNew" v-if="ipAdress">ip:{{ipAdress}}</div>
            <div class="fontNew" v-if="validityDate">数据库到期时间：:{{validityDate}}</div>
            <div class="fontNew" v-if="companyName">机构名称:{{companyName}}</div>
            <el-dropdown class="icons">
              <span class="el-dropdown-link keyicon">
                <img
                  @click="goPartSearch"
                  style="width: 20px; height: 20px;margin-top: 5px;"
                  src="/static/homenew/1.png"
                  alt=""
                />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click="goPartSearch"
                >部件检索</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown class="icons" v-if="isLogin">
              <button @click.stop="toPath('/uc')">
                <img
                  v-if="!isVip"
                  src="/static/homenew/user.svg"
                  class="buttonImg"
                />
                <div v-else><img src="/static/homenew/user.svg" /></div>
              </button>
              <el-dropdown-menu slot="dropdown">
                <a @click.stop="toPath('/uc')"
                ><el-dropdown-item>用户中心</el-dropdown-item></a
                >
                <a @click.stop="getout"
                ><el-dropdown-item>退出</el-dropdown-item></a
                >
                <!-- <router-link :to="{path:'/uc'}"><el-dropdown-item>用户中心</el-dropdown-item></router-link> -->
              </el-dropdown-menu>
            </el-dropdown>
            <div v-else class="icons" style="width: 96px;height: 32px;margin-left: 10px">
              <button @click.stop="toPath('/loginNew')" style="display: flex;padding: 5px 10px;width: 96px;height: 32px;background: #FFFFFF;border-radius: 16px;font-family: PingFangSC, PingFang SC;font-weight: 500;font-size: 16px;color: #573E0D;">
                <img src="/static/homenew/userNew.png" style="width: 14px;height: 13px;margin-top: 5px;margin-right: 10px;margin-left: 10px" /><span>登录</span>
              </button>
              <!--              <el-dropdown-menu slot="dropdown">
                              <a @click.stop="toPath('/login')"
                                ><el-dropdown-item>登録</el-dropdown-item></a
                              >
                            </el-dropdown-menu>-->
            </div>
          </div>
          <!--          <div style="z-index: 9" class="align-center">


                    </div>-->
        </div>
      </div>
    </el-collapse-transition>
    <el-dialog
      width="55%"
      height="540px"
      :visible.sync="buyVisible"
      :before-close="handleCloseBuy"
    >
      <BuyConfirm :visible.sync="buyVisible"></BuyConfirm>
    </el-dialog>
    <div class="yellowline"></div>
  </div>
</template>
<script>
var _czc = _czc || [];
(function () {
  var um = document.createElement("script");
  um.src = "https://v1.cnzz.com/z.js?id=1281427696&async=1";
  var s = document.getElementsByTagName("script")[0];
  s.parentNode.insertBefore(um, s);
})();
</script>
<script>
import eventBus from '@/utils/eventBus.js'
import {
  isCompanyUser
} from "@/api/api"
export default {
  name: 'App',
  // props: {
  //   isLogin: false,
  //   isVip: false,//是否vip
  // },
  data () {
    return {
      buyVisible: false,
      isLogin: false,
      isVip: false,// 是否vip
      ipAdress:'',
      validityDate:'',
      companyName:'',
      bookName:'',
      writer:'',
      bookVersion:'',
    }
  },
  mounted () {
    console.log(this.$route)
    this.isVip = localStorage.getItem('isVip') == 'null' ? false : localStorage.getItem('isVip')
    this.isLogin = !!localStorage.getItem('token')
    // window.addEventListener("mousemove", this.getgetPosY)
    // this.$bus.$on('caidanHide', this.caidanHide1)
    // 购买引导弹窗
    eventBus.$on('changeBuy', (v) => {
      this.changeBuy(v)
    })
    eventBus.$on('getBookDetail', (v) => {
        this.bookName=v.bookName
        this.writer=v.writer
        this.bookVersion=v.bookVersion
    })
  },
  created: function () {
    eventBus.$on('outLogin', type => {
      this.isLogin = !!localStorage.getItem('token')
    })
    isCompanyUser().then(res => {
      if(res.code === 200){
        if(res.data){
          this.ipAdress=res.data.ip
          if(res.data.validityDate){
            this.validityDate=res.data.validityDate.split('T')[0]
          }else{
            this.validityDate=res.data.validityDate
          }

          this.companyName=res.data.companyName
        }
      }
    })
  },
  watch: {
    $route: function (e) {
      this.hideSearch = e.path === '/' || e.path === '/search'
    }
  },
  methods: {
    goHome(){
      this.$router.push({
        path: '/'
      })
    },
    truncateText(text) {
      if (!text) return ''
      if (text.length <= 20) return text
      return text.substring(0, 20) + '...'
    },
    // 拼字输入法
    goPartSearch () {
      window.open('http://tlgj.bbtpress.com/partsearch/', '_blank')
    },
    changeBuy (isShow) {
      this.buyVisible = isShow
      // let ispre = this.$route.meta.prevPage
      if (!isShow && window.history.length == 1) { // 如果是新打开页面 关闭弹窗同时关闭页面
        window.close()
      }
    },
    handleCloseBuy (done) {
      // eventBus.$emit("changeBuy", false)
      // this.buyVisible = false
      this.changeBuy(false)
    },

    getout () {
      localStorage.removeItem('token')
      localStorage.removeItem('isVip')
      localStorage.removeItem('userinfo')
      this.$router.replace({
        path: '/'
      })
      this.isLogin = false
    },
    toPath (path) {
      this.$router.push({
        path: path
      })
    },
    toSearch (path) {
      this.$router.push({
        path: path
      }).catch(err => {
        // console.log('报错')
      })
      this.$bus.$emit('changeShow')
    }
    // scroll(){
    //   let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    //   console.log(scrollTop,'scrollTop');
    //   let open = true;
    //   if(open){
    //     open = false;
    //     setTimeout(()=>{
    //       if(scrollTop > 72){
    //       this.showHide = false;
    //     }else{
    //       this.showHide = true;
    //     }
    //     },1000);

    //   }
    // },
    // caidanHide1(){
    //   console.log('dddaaaa2');
    // this.showHide = true;
    // this.allShow = true;
    // },
    // caidanHide(){
    //   console.log('dddaaaa');
    //   if(this.indexShow){
    //   // if(this.$route.name=='Home'){
    //   setTimeout(()=>{
    //       this.showHide = false;
    //     },1000);
    //   }else{

    //       this.showHide = true;

    //   }
    // },
    // getgetPosY () {
    //   // console.log(111);
    //   // if(this.$route.name=='Home'){
    //   if (this.indexShow) {
    //     let posY = 0
    //     var event = event || window.event
    //     let ischan = true
    //     if (ischan) {
    //       ischan = false
    //       setTimeout(() => {
    //         if (event.pageY) {
    //           posY = event.pageY
    //         } else if (event.clientY) {
    //           posY = event.clientY + document.documentElement.scrollTop + document.body.scrollTop
    //         }
    //         // console.log(posY,'posY');
    //         if (posY < 20) {
    //           this.showHide = true
    //         } else if (posY > 150) {
    //           if (this.allShow) {
    //             this.showHide = true
    //           } else {
    //             this.showHide = false
    //           }
    //         }
    //       }, 1000)
    //     }
    //   }
    // }
  },
  beforeDestroy () {
    // this.$bus.$off("caidanHide")
    eventBus.$off('changeBuy')
  }
}
</script>

<style lang="less" scoped>
@primary-color: #f4f0e8;

@PingFangSC-Regular: PingFangSC-Regular;
@PingFang-SC-Bold: PingFang-SC-Bold;
.eline {
  color: rgba(238, 238, 238, 0.4);
}
.keyicon {
  display: flex;
  align-items: center;
}
.fontNew2{
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #FFFFFF;
  opacity: 0.65;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
  margin-right: 10px;
  margin-left: 10px;
  margin-top: 5px;
}
.headcenter {
  margin-right: 2%;
  display: flex;
  justify-content: left;
  align-items: center;
  //width: 50%;
  height: 64px;
  .fontNew{
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #FFFFFF;
    opacity: 0.65;
    letter-spacing: 0;
    text-align: center;
    line-height: 18px;
    font-weight: 400;
    margin-right: 10px;
  }
  .menucontent {
    width: 116px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    margin-top: 5px;
    a {
      // color: @primary-color;
      // font-size: 14px;
      // letter-spacing: 0;
      // font-weight: 400;
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #FFFFFF;
      opacity: 0.65;
      letter-spacing: 0;
      text-align: center;
      line-height: 18px;
      font-weight: 400;
    }
  }
  .menucontent:hover {
    // background: #0e6e7f;
    //background: #0e6e7f;
    cursor: pointer;
    a{
      font-weight: bold;
    }
   /* background: #F9CE68;
    border-radius: 4px;
    a{
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #573E0D;
    }*/
  }
  .activemetl {
    // margin-bottom: 1px;
    background: #F9CE68;
    border-radius: 4px;
    a{
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #573E0D;
    }
  }
  .navLine{
    width: 90px;
    margin-left: 13px;
    height: 2px;
    background: #F9CE68;
    border-radius: 1px;
    margin-top: 3px;
  }
}

.mes {
  width: 20px;
  height: 20px;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
  }
  margin-left: 0.8rem;
}
.mesnum {
  height: 20px;
  min-width: 30px;
  margin-left: 5px;
  background: #ff3b30;
  border-radius: 10.25px 10.25px 10.25px 0px;
  font-family: HelveticaNeue;
  font-size: 12px;
  color: #ffffff;
  font-weight: 400;
  text-align: center;
}
.yellowline {
  width: 100%;
  height: 2px;
  background-image: linear-gradient(
    90deg,
    #a4894f 0%,
    #d1be87 49%,
    #a4894f 100%
  );
}
.logobox {
  // width: 36px;
  // height: 36px;
  // border-radius: 50%;
  // background: #ececec;
  // margin-right: 10px;
}
/deep/.el-dialog__body {
  padding: 0;
}
/deep/.el-dialog__header {
  padding: 0;
}
/deep/.el-dialog {
  border-radius: 10px;
}
button {
  cursor: pointer;
}
.el-dropdown-menu__item {
  line-height: 25px;
  padding: 0 5px;
}
.el-dropdown-menu {
  padding: 5px;
  text-align: center;
}
.icons {
  // display: inline-block;

  // margin-left: 0.6316rem;
  font-family: "Courier New", Courier, monospace;
  width: 2.36rem;
  height: 1.88rem;
  // border-radius: 5px;
  // width: 45px;
  // height: 36px;
  cursor: pointer;

  // border-radius: 0.53rem;
  // opacity: 0.49;
  // position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  button {
    width: 28px;
    height: 28px;
  }
  img {
    z-index: 999;
    width: 100%;
    height: 100%;
    // width: 24px;
    // height: 24px;

    // align-items: center;
    // position: absolute;
    // left: 0.56rem;
    // top: 0.33rem;
    //  left:10.7px;
    //  top:6.27px;
  }
  // position: relative;
  // .buttonImg {
  //   width: 1.26rem;
  //   height: 1.26rem;
  //   background-size: 100% 100%;
  // }

  // .imgtop{
  //   position:absolute;
  //   width: 1.3rem;
  //   height: 1.5rem;
  //   left:.25rem;
  //   top:.1rem;
  // }
}
.icons:hover {
  background-image: url(/static/bg.png);
  // background-color: #ccc;
  background-size: 100% 100%;
}

.header-bg {
  // position: fixed;
  // top:0;
  // left: 0;
  // z-index: 10000;
  //background: url(/static/header-bg.png) no-repeat;
  background: linear-gradient( 90deg, #203D4D 0%, #20425A 46%, #203B4E 100%);
  background-size: cover;
  height: 64px;
  width: 100%;
  filter: brightness(1.1);
}
a {
  text-decoration: none;
}
.router-link-active {
  text-decoration: none;
}
.navInBox {
  line-height: 2rem;
  padding-left: 1rem;
  font-size: 0.8rem;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  // padding-right: 3rem;

  .logo {
    margin-left: 5%;
    cursor: pointer;
    display: flex;
    align-items: center;
    img {
      height: 3.4rem;
    }
    .logo-font {
      // color: #fff;
      // color: @primary-color;
      // font-family: @PingFang-SC-Bold;
      // font-weight: 700;
      // font-size: 18px;
      // line-height: 64px;
      // color: #f4f0e8;
      // letter-spacing: 0;
      // padding-top: 0.8rem;
      // font-family: FZKTFW;
      // font-family: 'FangZheng-FanTi';
      font-family: STSongti-SC, STSongti-SC;
      font-weight: 900;
      font-size: 18px;
      color: #F5EBC9;
      letter-spacing: 0;
      line-height: 24px;
    }
    .logo-name{
      font-family: STSongti-SC, STSongti-SC;
      font-weight: 400;
      font-size: 12px;
      color: #FFFFFF;
    }
  }
  .nav {
    padding: 1rem 0 0.5rem;
  }
  .to-login {
    font-size: 1rem;
    color: #fff;
    cursor: pointer;
    padding: 0.5rem 0 0 0;
  }

  .user-icon {
    width: 24px;
    height: 24px;
    background: rgba(204, 204, 204, 0.49);
    opacity: 0.49;
    border-radius: 0.2rem;
    line-height: 1.86rem;
    cursor: pointer;
    img {
      width: 1.25rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue